<template>
  <div>
    <el-form
      @submit.native.prevent="submitRequest"
      class="inspection-request"
      :rules="rules"
      v-loading="loading"
      :inline="true"
      :model="formData"
      ref="formInspectionNew"
    >
      <div v-if="lead.first_name">
        <h6 class="heading-small text-muted mb-4">
          New Inspection Request
        </h6>
        <div>
          <div class="row">
            <div class="col-lg-10">
              <h3 v-if="isEventTypeWedding">
                <span class="text-muted">For</span> {{ lead.first_name }}
                {{ lead.last_name }} & {{ enquiry && enquiry.partners_first_name }}
                {{ enquiry && enquiry.partners_last_name }}
              </h3>
              <h3 v-else>
                <span class="text-muted">For</span> {{ lead.first_name }}
                {{ lead.last_name }}
              </h3>
              <small class="text-muted">Event Date: {{ enquiry && enquiry.event_date | moment("DD MMM YYYY") }}</small>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <h6 class="heading-small text-muted mb-2 ">
        <div class="row">
          <div class="col-lg-7" v-if="shortlists">
            <i class="ni ni-building"></i> 
            <span>
              Confirm Venues 
            </span>
          </div>
          <div class="col-lg-8" v-if="venue && venue.id">
            <span>
              Venue
            </span>
          </div>
          <div class=" text-center" :class="(venue && venue.id) ? `col-lg-5` : `col-lg-6`">
            <strong>AUTOMATION</strong>
          </div>
        </div>
      </h6>
      <div class="row sub-heading-for-automation heading-small">
        <div :class="(venue && venue.id) ? `col-lg-8` : `col-lg-7`">
        </div>
        <div class="text-center" :class="(venue && venue.id) ? `col-lg-4` : `col-lg-5`">
          <div class="row">
            <div class="col-lg-3"><strong>VENUE</strong></div>
            <div class="col-lg-9"><strong>LEAD</strong></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-xs" :class="(venue && venue.id) ? `col-lg-3` : `col-lg-2`"><strong>VENUE</strong></div>
        <div class="col-lg-1 space-column mb-3 text-xs"><strong>SPACE</strong></div>
        <div class="col-lg-3 time-column mb-3 text-xs"><strong>TIME/DATE</strong></div>
        <div class="col-lg-2 status-column mb-3 text-xs"><strong>STATUS</strong></div>
        <div class="col-lg-1 send-mail-column mb-3 text-xs automation-right-border" :class="(venue && venue.id) ? `col-lg-2 text-center` : `col-lg-1`">CONFIRM</div>
        <div class="col-lg-1 send-mail-column mb-3 text-xs" :class="(venue && venue.id) ? `col-lg-2 text-center` : `col-lg-1`">CONFIRM</div>
        <div class="col-lg-1 send-mail-column mb-3 text-xs" :class="(venue && venue.id) ? `col-lg-2 text-center` : `col-lg-1`">REMINDER</div>
        <div class="col-lg-1 send-mail-column mb-3 text-xs" :class="(venue && venue.id) ? `col-lg-2 text-center` : `col-lg-1`">FOLLOW-UP</div>
        <div class="col-lg-2 sync-column mb-3 text-xs" v-if="! (venue && venue.id)"><strong>SYNC</strong></div>
      </div>
      <div class="row"  v-if="venue && venue.id">
        <div class="col-lg-3 mb-3 inspectionvenue">
          {{ venue.name }}
        </div>
        <div class="col-lg-1 space-column select-a-space-borderless">
          <el-select
            v-model="isSpaceSelected[venue.id]" class="selectinspectionspace" placeholder="Space" size="mini"
            @change="spaceChanged(venue.id)">
            <el-option
              key="-11" label="- Entire Venue -"
              value="default_venue_timing"
              class="entire"
            >
            </el-option>
            <el-option
              v-for="(room, room_name) in venue.rooms"
              :key="room_name"
              :label="room_name"
              :value="room_name">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-3 time-column">
          <base-button
            type="secondary"
            native-type="button"
            class="date_and_time_select_button"
            size="sm"
            @click="showSelectDateTime(venue)"
            v-if="isSpaceSelected[venue.id] && showSelectedDateTime(venue) === ''"
          >
            Select time/date
          </base-button>
          <span class="text-xs d-block" v-if="showSelectedDateTime(venue) !== ''">
            {{showSelectedDateTime(venue)}}
            <i class="ni ni-calendar-grid-58" @click="showSelectDateTime(venue)"></i>
          </span>
        </div>
        <div class="col-lg-2 status-column mb-3 select-a-space-borderless">
          <el-select
            v-model="formData.status[venue.id]" placeholder="Status" size="mini" >
            <el-option
              :key="InspectionService.INSPECTION_STATUS_REQUESTED"
              label="Requested"
              :value="InspectionService.INSPECTION_STATUS_REQUESTED"
            >
            </el-option>
            <el-option
              :key="InspectionService.INSPECTION_STATUS_CONFIRMED"
              label="Confirmed"
              :value="InspectionService.INSPECTION_STATUS_CONFIRMED"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center automation-right-border">
          <el-checkbox v-model="formData.send_mail_venue_confirm[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_confirm[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_reminder[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_followup[venue.id]">
          </el-checkbox>
        </div>
      </div>
      <div class="row" v-for="venue in shortlists" :key="venue.id" v-if="shortlists && shortlists.length">
        <div class="col-lg-2 mb-3 inspectionvenue">
          <base-checkbox v-model="formData.venues[venue.id]">
            {{ venue.name }}
          </base-checkbox>
        </div>
        <div class="col-lg-1 space-column select-a-space-borderless">
          <el-select
            v-model="isSpaceSelected[venue.id]" class="selectinspectionspace" placeholder="Space" size="mini"
            @change="spaceChanged(venue.id)">
            <el-option
              key="-1" label="- Entire Venue -"
              value="default_venue_timing"
              class="entire"
            >
            </el-option>
            <el-option
              v-for="room in venue.rooms"
              :key="room"
              :label="room"
              :value="room">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-3 time-column">
          <base-button
            type="secondary"
            native-type="button"
            size="sm"
            class="selectinspectiondate"
            @click="showSelectDateTime(venue)"
            v-if="isSpaceSelected[venue.id] && showSelectedDateTime(venue) === ''"
          >
            time/date
          </base-button>
          <span class="text-xs" v-if="showSelectedDateTime(venue) !== ''">
            {{showSelectedDateTime(venue)}}
            <i class="ni ni-calendar-grid-58" @click="showSelectDateTime(venue)"></i>
          </span>
        </div>
        <div class="col-lg-2 status-column mb-3 select-a-space-borderless">
          <el-select
            v-model="formData.status[venue.id]" placeholder="Status" size="mini" >
            <el-option
              :key="InspectionService.INSPECTION_STATUS_REQUESTED"
              label="Requested"
              :value="InspectionService.INSPECTION_STATUS_REQUESTED"
            >
            </el-option>
            <el-option
              :key="InspectionService.INSPECTION_STATUS_CONFIRMED"
              label="Confirmed"
              :value="InspectionService.INSPECTION_STATUS_CONFIRMED"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center automation-right-border">
          <el-checkbox v-model="formData.send_mail_venue_confirm[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_confirm[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_reminder[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-1 send-mail-column mb-3 text-center">
          <el-checkbox v-model="formData.send_mail_lead_followup[venue.id]">
          </el-checkbox>
        </div>
        <div class="col-lg-2 sync-column mb-3">
          <VenueAvailabilityBadge :venue="venue" />
        </div>
      </div>
      <hr />
      <h6 class="heading-small text-muted mb-4">
        <i class="ni ni-building"></i> Additional Details
      </h6>

      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">Add Message</label>
            <textarea
              rows="6"
              class="form-control"
              id="details_text_area"
              v-model="formData.message"
              placeholder=""
            >
          </textarea>
          </div>
        </div>
      </div>

      <input
        type="hidden"
        rows="6"
        class="form-control"
        :value="formData.date"
        placeholder=""
      />
      <base-button
        type="primary"
        native-type="submit"
        id="submit_new_inspection_request"
        class="my-4"
        :disabled="checkCheckboxes"
      >
        Send Request
      </base-button>
    </el-form>


    <el-dialog
      title="Select a Date & Time"
      width="640px"
      v-loading="loading"
      :visible.sync="showSelectDateTimeModel"
      v-if="showSelectDateTimeModel"
      :append-to-body="true"
    >
      <div class="row">
        <InspectionChecklist v-if="inspectionChecklistCompletionRequired && !checkListCompleted" :venue="selectedVenue" @complete="checkListCompleted = true" />
        <SelectInspectionDate v-if="! inspectionChecklistCompletionRequired ? true : checkListCompleted" :venue="selectedVenue" :availability="selectedVenuesAvailability" @confirm="setSelectedVenueTime"/>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import InspectionService from "@/services/inspection.service";
import InspectionChecklist from "@/views/Widgets/Inspections/InspectionChecklist.vue";
import SelectInspectionDate from "@/views/Widgets/Inspections/SelectInspectionDate.vue";
import VenueAvailabilityBadge from "@/views/Widgets/Inspections/VenueAvailabilityBadge.vue";
import { DatePicker, dialog, Form, FormItem, Option, Select, TimeSelect, Checkbox } from "element-ui";
import moment from 'moment';
import momenttz from 'moment-timezone';
import timezoneMixin from '@/helpers/timezoneMixin';

export default {
  name: "new-inspection-form",
  props: {
    lead: {
      required: true,
    },
    enquiry: {
      required: true,
    },
    shortlists: {
      required: false,
    },
    venue_id: {
      required: false,
    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [FormItem.name]: FormItem,
    [Form.name]: Form,
    [TimeSelect.name]: TimeSelect,
    [Select.name]: Select,
    [Option.name]: Option,
    [dialog.name]: dialog,
    [Checkbox.name]: Checkbox,
    SelectInspectionDate,
    InspectionChecklist,
    VenueAvailabilityBadge,
  },
  data(){
    return {
      loading: true,
      checkListCompleted: false,
      formData: {
        venues: {},
        times: {},
        timezones: {},
        send_mail_venue_confirm: {},
        send_mail_lead_confirm: {},
        send_mail_lead_reminder: {},
        send_mail_lead_followup: {},
        message: '',
        spaces: {},
        status: {},
      },
      pickerData: {
        date: {},
        time: {}
      },
      rules: {
        date: [
          {
            type: "date",
            required: true,
            message: "Please pick a date",
            trigger: "blur",
          },
        ],
      },
      inspection_timezone: "",
      showSelectDateTimeModel: false,
      selectedVenue:{},
      selectedVenuesAvailability: {},
      isSpaceSelected: {},
      InspectionService,
    };
  },
  async mounted() {
    if (this.venue_id) {
      await this.$store.dispatch("venues/getSingle", {
        lead: this.lead.id,
        id: this.venue_id,
      });
      this.$set(this.formData.venues, this.venue_id, true);
    }
    this.loading = false;
  },
  updated() {
    if (!this.inspection_timezone) {
      this.inspection_timezone = this.lead.timezone;
    }
  },
  computed: {
    today() {
      return moment().format();
    },
    venue() {
      return this.$store.getters["venues/getVenueById"](this.venue_id);
    },
    checkCheckboxes() {
      let isGood = true;
      let selectedLeastOne = false;
      for (const key in this.formData.venues) {
        if (this.formData.venues[key] === true) {
          selectedLeastOne = true;
        }
        if ((this.formData.venues[key] === true && !this.formData.times[key])) {
          isGood = false;
        }
        if ((this.formData.venues[key] === true && !this.formData.spaces[key])) {
          isGood = false;
        }
      }
      if (!selectedLeastOne) {
        isGood = false;
      }
      return !isGood;
    },
    isEventTypeWedding() {
      return this.enquiry?.eventType?.toLowerCase() === 'wedding';
    },
    inspectionChecklistCompletionRequired() {
        return this.enquiry?.event_type?.toLowerCase() !== 'corporate';
    }

  },
  mixins: [timezoneMixin],
  methods: {
    spaceChanged(venue_id) {
      this.$set(this.formData.times, venue_id, undefined);
      this.$set(this.formData.timezones, venue_id, undefined);
    },
    getConvertedTimes(times, fromTimezone, toTimezone) {
      let temp = {};
      Object.keys(times).forEach(function (key){
        var date = moment(key);
        if (key && date.isValid()) {
          times[key].forEach((unavailable_times) => {
            let unavailable_start = momenttz.tz(moment(key + ' ' + unavailable_times.start, 'YYYY-MM-DD hh:mm A').format('YYYY-MM-DD HH:mm'), fromTimezone);
            unavailable_start = unavailable_start.tz(toTimezone);
            let unavailable_end = momenttz.tz(moment(key + ' ' + unavailable_times.end, 'YYYY-MM-DD hh:mm A').format('YYYY-MM-DD HH:mm'), fromTimezone);
            unavailable_end = unavailable_end.tz(toTimezone); 
            if (temp[key]  === undefined) {
              temp[key] = [];
            }
            temp[key].push({
              start: moment(unavailable_start).format('hh:mm A'),
              end: moment(unavailable_end).format('hh:mm A'),
            });
          });
        } 
      });
      return temp;
    },
    showSelectDateTime(venue) {
      this.checkListCompleted = false; 
      this.showSelectDateTimeModel = true;
      this.selectedVenue = venue;
      let space = this.isSpaceSelected[venue.id];
      let availability = venue.availability ? venue.availability[space] : [];
      if (!availability || !availability.specified_availabilities) {
        let availability_temp = availability;
        availability = venue.availability && venue.availability['default_venue_timing'] ? venue.availability['default_venue_timing'] : [];
        let unavailable_temp = this.getConvertedTimes(availability_temp.unavailable, availability_temp.timezone, venue.availability['default_venue_timing'].timezone);
        availability.unavailable = {...unavailable_temp, ...availability.unavailable};
      }
      this.selectedVenuesAvailability = availability;
    },
    submitRequest() {
      if (this.venue_id) {
        this.$refs["formInspectionNew"].validate(async (valid) => {
          if (valid) {
            this.$emit("submitRequest", this.formData);
            this.resetForm();
          }
        });
      } else {
        this.$emit("submitRequest", this.formData);
        this.resetForm();
      }
    },
    resetForm() {
      this.formData.venues = {};
      this.formData.times = {};
      this.pickerData.date = {};
      this.pickerData.time = {};
      this.formData.spaces = {};
      this.formData.send_mail_venue_confirm = {};
      this.formData.send_mail_lead_confirm = {};
      this.formData.send_mail_lead_reminder = {};
      this.formData.send_mail_lead_followup = {};
      this.formData.message = '';
    },
    setSelectedVenueTime(data) {
      let space = this.isSpaceSelected[data.venue_id];
      this.$set(this.formData.times, data.venue_id, data.date);
      this.$set(this.formData.timezones, data.venue_id, data.timezone);
      this.$set(this.formData.venues, data.venue_id, true);
      this.$set(this.formData.spaces, data.venue_id, space);
      if (this.formData.status[data.venue_id] !== InspectionService.INSPECTION_STATUS_CONFIRMED) {
        this.$set(this.formData.status, data.venue_id, InspectionService.INSPECTION_STATUS_REQUESTED);
      }
      this.showSelectDateTimeModel = false;
    },
    showSelectedDateTime(venue) {
      if (!this.formData.times[venue.id]) {
        return '';
      }
      let dateObj = moment(this.formData.times[venue.id], 'YYYY-MM-DD hh:mm A');
      let date = moment.tz(dateObj.format('YYYY-MM-DD HH:mm'), this.formData.timezones[venue.id]);
      return date.format("ddd, MMM Do YYYY, h:mm a z");
    },
  },
  watch: {
    'formData.venues': {
      handler(newVenues) {
        Object.keys(newVenues).forEach(venueId => {
          if (newVenues[venueId] === true) {
            // If venue is selected and send_mail is not set for this venue
            if (this.formData.send_mail_venue_confirm[venueId] === undefined) {
              // Set it to true by default
              this.$set(this.formData.send_mail_venue_confirm, venueId, true);
            }

            if (this.formData.send_mail_lead_confirm[venueId] === undefined) {
              // Set it to true by default
              this.$set(this.formData.send_mail_lead_confirm, venueId, true);
            }

            if (this.formData.send_mail_lead_reminder[venueId] === undefined) {
              // Set it to true by default
              this.$set(this.formData.send_mail_lead_reminder, venueId, true);
            }

            if (this.formData.send_mail_lead_followup[venueId] === undefined) {
              // Set it to true by default
              this.$set(this.formData.send_mail_lead_followup, venueId, true);
            }

            // If it's already set (true or false), leave it as is
          } else {
            // If venue is deselected, remove it from send_mail
            if (this.formData.send_mail_venue_confirm[venueId] !== undefined) {
              this.$delete(this.formData.send_mail_venue_confirm, venueId);
            }

            if (this.formData.send_mail_lead_confirm[venueId] !== undefined) {
              this.$delete(this.formData.send_mail_lead_confirm, venueId);
            }

            if (this.formData.send_mail_lead_reminder[venueId] !== undefined) {
              this.$delete(this.formData.send_mail_lead_reminder, venueId);
            }

            if (this.formData.send_mail_lead_followup[venueId] !== undefined) {
              this.$delete(this.formData.send_mail_lead_followup, venueId);
            }
          }
        });
      },
      deep: true
    }
  }
};
</script>
<style>
.select-a-space-borderless .el-input__inner {
  border: none !important;
  padding-left: 0 !important;
}
.select-a-space-borderless .el-input--mini .el-input__inner {
  height: 28px !important;
}
@media (min-width: 992px) {
  .inspection-request .col-lg-1.space-column  {
    flex: 0 0 10%;
    max-width: 10%;
  }
  .inspection-request .col-lg-3.time-column  {
    flex: 0 0 19%;
    max-width: 19%;
  }
  .inspection-request .col-lg-2.status-column  {
    flex: 0 0 9%;
    max-width: 9%;
  }
  .inspection-request .col-lg-1.send-mail-column  {
    flex: 0 0 7.3%;
    max-width: 7.3%;
    font-size: 11px !important;
  }
  .inspection-request .col-lg-2.sync-column  {
    flex: 0 0 13%;
    max-width: 13%;
  }
  h6.heading-small .col-lg-7,
  .sub-heading-for-automation .col-lg-7 {
    flex: 0 0 53.7%;
    max-width: 53.7%;
  }
  h6.heading-small .col-lg-5,
  .sub-heading-for-automation .col-lg-5{
    flex: 0 0 30%;
    max-width: 30%;
  }

   h6.heading-small .col-lg-8,
  .sub-heading-for-automation .col-lg-8 {
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  h6.heading-small .col-lg-4,
  .sub-heading-for-automation .col-lg-4{
    flex: 0 0 30%;
    max-width: 30%;
  }

  .inspection-request .automation-right-border::after {
   content: "";
    position: absolute;
    right: 0;
    top: -20px;
    width: 1px;
    height: 230%;
    background-color: #e9ecef;
    z-index: 1;
  }
}
</style>